import { INPUT_TYPES } from '../utils/constants.js';
export default {
    title: 'Video Play Button on thumbnails',
    isRelevant: () => true,
    isRelevantDescription: 'Always relevant.',
    type: INPUT_TYPES.BOOLEAN,
    default: false,
    description: `Show video play button on thumbnails in a thumbnail gallery`,
};
//# sourceMappingURL=behaviourParams_item_video_enableThumbnailsPlayButton.js.map